import { FC, ReactElement, ReactNode, RefObject } from 'react';
import { EActions } from 'reactApp/modules/storage/storage.types';
import { DropdownTheme, ListItem } from 'reactApp/ui/DropdownList/DropdownList';

export type TToolbarDropdownItem = ListItem & { hotkeyLabel?: string; withStatus?: boolean; active?: boolean; asc?: boolean };

export enum EDropdownPosition {
    right = 'right',
    left = 'left',
}

export enum EToolbarItemMod {
    blue = 'blue',
}

export interface IToolbarItemProps {
    id?: EActions | string;
    text?: string | ReactElement;
    onClick?: () => void;
    hint?: string;
    icon?: ReactNode;
    collapse?: boolean;
    parentRef?: RefObject<HTMLElement>;
    list?: TToolbarDropdownItem[];
    withoutDropdownIcon?: boolean;
    dropdownTheme?: DropdownTheme;
    dropdownPosition?: EDropdownPosition;
    openDropdownByArrow?: boolean;
    mod?: EToolbarItemMod;
}

export type ToolbarItemProps = Record<string, any> & { parentRef?: RefObject<HTMLElement> };
export type ToolbarItem = FC<ToolbarItemProps>;
export type TToolbarItem = IToolbarItemProps & { Item?: ToolbarItem | null; itemProps?: ToolbarItemProps; priority?: number };
